import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { RouterConfig } from '@edikk-edikk/country-frontend';
import { useBaseContext } from '#base/hooks';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailHeaderLocationCss from '../../assets/header/header-location.module.scss';

const HeaderInfoLocation: FC = () => {
  const { isBot } = useBaseContext();
  const {
    advert: {
      city,
      isDeleted,
    },
  } = useAdvertDetailContext();
  const { isSingleCity } = useBaseContext();

  if (isSingleCity) {
    return null;
  }

  if (!isBot && isDeleted) {
    return null;
  }

  return (
    <div className={advertDetailHeaderLocationCss.advertDetailHeaderLocation}>
      <FormattedMessage defaultMessage="Available in:" />
      <Link
        to={city.url}
        state={{ routerConfig: RouterConfig.initForCity(city.id) }}
        className={advertDetailHeaderLocationCss.advertDetailHeaderLocation__value}
      >
        {city.title}
      </Link>
    </div>
  );
};

export { HeaderInfoLocation };
